import { t } from "./to-primitive.js";
var r = TypeError,
  n = function n(_n) {
    var o = t(_n, "number");
    if ("number" == typeof o) throw r("Can't convert number to bigint");
    return BigInt(o);
  };
export { n as t };